






















import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import Pie from './Pie.vue';
import PieGroup from './PieGroup.vue';

@Component({
  components: {
    Pie,
    PieGroup,
  },
})

export default class GroupList extends Vue {
    @Prop({ default: false }) private auth!: boolean;

    get isAdmin(): boolean {
      return this.$route.path === '/admin';
    }

    isOff(status: boolean): boolean {
      return this.isAdmin && !status;
    }

    isVisible(status: boolean): boolean {
      return this.isAdmin || status;
    }

    get groups() {
      return this.$store.state.groups;
    }
}
